import React, { useEffect, useState } from 'react';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

interface DownloadButtonProps {
  styles?: string | 'btn-primary';
}

const DownloadButton = ({ styles }: DownloadButtonProps) => {
  const [files, setFiles] = useState(null);
  const [loading, setLoading] = useState(false);

  const getFiles = async () => {
    const res = await fetch(`${process.env.NEXT_PUBLIC_BASE_URL}/api/files`);
    const files = await res.json();

    setFiles(files);
  };

  useEffect(() => {
    getFiles();
  }, []);

  const downloadResourcesOnClick = async () => {
    setLoading(true);
    try {
      const zip = new JSZip();
      const remoteZips = files.map(async file => {
        const response = await fetch(file.url);
        const data = await response.blob();
        zip.file(`${file.name}.${file.type}`, data);

        return data;
      });

      Promise.all(remoteZips)
        .then(() => {
          zip.generateAsync({ type: 'blob' }).then(content => {
            // give the zip file a name
            saveAs(content, 'fhnw-styleguide-v5.zip');
          });
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        onClick={downloadResourcesOnClick}
        disabled={loading}
        className={`btn ${styles}`}
      >
        FHNW Bootstrap Styleguide V5 (ZIP)
      </button>
    </>
  );
};

export default DownloadButton;
